import { getSingleParam } from '@/services/validation/defaultValidators/utils'

const isNotValidator = (value: unknown, params: [unknown] | { other: unknown }) => {
  const other = getSingleParam(params, 'other')

  return value !== other
}

export default isNotValidator
